<template>
  <div class="content-print-content">
    <div class="holder container">
      <div class="content-confirm-postcard col-md-10 col-lg-7 col-12">
        <div class="d-flex justify-content-center w-100 mt-4" :class="isiPad ? 'mb-5' : 'mb-4'">
          <div :class="['content-print-content-body', 'mt-0','mb-0', {'p-0': isMobile}]">
            <div class="content-print-content-body-item m-0 mr-2">
              <div class="d-table w-100 h-100">
                <div class="d-table-cell align-middle text-center">
                  <p>{{$t('front_end.a060.front')}}</p>
                  <img :src="frontImage" class="img-print img-border" v-if="postcardSelect" />
                  <div class="img-print img-border" ref="imgFont" v-else></div>
                </div>
              </div>
            </div>
            <div class="content-print-content-body-item m-0 ml-2">
              <div class="d-table w-100 h-100">
                <div class="d-table-cell align-middle text-center">
                  <p>{{$t('front_end.a060.behind')}}</p>
                  <img
                    :src="behindImage"
                    class="img-print img-border"
                    ref="imgBehind"
                    @load="setFrameImg"
                    v-if="behindImage"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ValidationObserver ref="form">
          <form @submit.prevent="onSubmit">
            <div class="content-print-content-font">
              <p class="content-print-content-font-ttl">
                {{$t('front_end.a060.postcard_select')}}
                <span class="note-required">*</span>
              </p>
              <ValidationProvider
                mode="passive"
                vid="postcardSelect"
                :name="$t('front_end.a060.postcard_select')"
                rules="required"
                v-slot="{ errors }"
              >
                <div class="select-box">
                  <font-awesome-icon icon="angle-down" class="icon-select" />
                  <select
                    class="form-control content-print-content-font-select select-postcard"
                    v-model="postcardSelect"
                    id="selectPostCard"
                    ref="selectPostCard"
                  >
                    <option
                      :value="null"
                      disabled
                      selected
                    >{{$t('front_end.a060.combobox_placeholder')}}</option>
                    <option
                      :value="postcard.postCardName"
                      v-for="(postcard, i) in postcardList"
                      :key="i"
                    >{{postcard.postCardName}}</option>
                  </select>
                </div>
                <p
                  class="w-100 text-left mt-2 message-error"
                  v-if="errors.length !== 0"
                >{{ $t('front_end.a060.validate.postcard_select_required')}}</p>
              </ValidationProvider>
              <ValidationProvider
                mode="passive"
                vid="inputTotal"
                :name="$t('front_end.a060.number_print')"
                rules="required|max:4|half_size|numeric|max_value:1000|min_value:1"
                v-slot="{ errors, failedRules }"
              >
                <div class="content-enter-number-sheet mt-4">
                  <div class="input-total">
                    <p class="content-print-content-font-ttl">
                      {{$t('front_end.a060.enter_number_print')}}
                      <span class="note-required">*</span>
                    </p>
                    <p
                      class="w-100 m-0 message-error"
                      v-if="!isReOrder"
                    >{{ $t('front_end.a060.validate.number_new_order_required') }}</p>
                    <p
                      class="w-100 m-0 message-error"
                      v-if="failedRules.half_size"
                    >{{$t('front_end.a060.validate.sheet_half_size')}}</p>
                    <p
                      class="w-100 m-0 message-error"
                      v-else-if="failedRules.required"
                    >{{$t('front_end.a060.enter_number_print')}}</p>
                    <p
                      class="w-100 m-0 message-error"
                      v-else-if="failedRules.max_value || failedRules.min_value"
                    >{{$t('front_end.a060.validate.number_postcard_except')}}</p>
                    <p
                      class="w-100 m-0 message-error"
                      v-else-if="errors.length !== 0"
                    >{{ errors[0] }}</p>
                    <p
                      class="w-100 m-0 message-error"
                      v-else-if="isNumberPrintError.length !== 0"
                    >{{$t(isNumberPrintError[0])}}</p>
                  </div>
                  <div class="enter-number-sheet">
                    <input
                      :type="inputType"
                      class="form-control content-enter-input mr-2 p-0"
                      v-model.trim="inputTotal"
                      :pattern="dynamicPattern"
                    />
                    <p class="m-0">{{$t('front_end.a060.sheet')}}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                mode="passive"
                vid="postcardBrings"
                :name="$t('front_end.a060.number_print_bring')"
                rules="required|max:4|half_size|numeric"
                v-slot="{ errors, failedRules }"
                v-if="isCanBringPostCard"
              >
                <div class="content-enter-number-sheet mt-4">
                  <div class="input-total">
                    <p class="content-print-content-font-ttl">
                      {{$t('front_end.a060.enter_number_print_bring')}}
                      <span class="note-required">*</span>
                    </p>
                    <p
                      class="w-100 m-0 message-error"
                      v-if="failedRules.half_size"
                    >{{$t('front_end.a060.validate.bring_number_half_size')}}</p>
                    <p
                      class="w-100 m-0 message-error"
                      v-else-if="errors.length !== 0"
                    >{{ errors[0] }}</p>
                    <p
                      class="w-100 m-0 message-error"
                      v-else-if="isBringIntoQuantityError.length !== 0"
                    >{{$t(isBringIntoQuantityError[0])}}</p>
                  </div>
                  <div class="enter-number-sheet">
                    <input
                      :type="inputType"
                      class="form-control content-enter-input mr-2 p-0"
                      v-model.trim="postcardBring"
                      :pattern="dynamicPattern"
                    />
                    <p class="m-0">{{$t('front_end.a060.sheet')}}</p>
                  </div>
                </div>
              </ValidationProvider>
              <div>
                <div class="line-end" v-if="!isReOrder"></div>
                <div class="content-enter-number-sheet" v-if="printReceiver">
                  <p
                    class="content-print-content-font-ttl message-enter-number-print"
                  >{{$t('front_end.a060.message_enter_print_sheet')}}</p>
                </div>
                <div class="content-enter-number-sheet mt-0" v-if="printReceiver">
                  <p
                    class="content-print-content-font-ttl"
                  >{{$t('front_end.a060.number_of_registered_address')}}</p>
                  <div class="enter-number-sheet">
                    <input
                      type="text"
                      class="form-control content-enter-input mr-2 p-0"
                      disabled
                      v-model="addressReceiverNumber"
                    />
                    <p class="m-0">{{$t('front_end.a060.sheet')}}</p>
                  </div>
                </div>
                <div class="content-enter-number-sheet" v-if="printReceiver">
                  <p
                    class="content-print-content-font-ttl m-0"
                  >{{$t('front_end.a060.number_of_copies')}}</p>
                  <div class="enter-number-sheet">
                    <input
                      type="text"
                      class="form-control content-enter-input mr-2 p-0"
                      disabled
                      v-model.trim="noneAddressReceiverNumber"
                    />
                    <p class="m-0">{{$t('front_end.a060.sheet')}}</p>
                  </div>
                </div>
                <span v-if="printReceiver">
                  <div class="total-number-print">
                    <p
                      class="m-0 mr-2 content-print-content-font-ttl"
                    >{{$t('front_end.a060.total')}}</p>
                    <div class="enter-number-sheet">
                      <input
                        class="form-control content-enter-input mr-2 p-0"
                        disabled
                        v-model="total"
                      />
                      <p class="m-0">{{$t('front_end.a060.sheet')}}</p>
                    </div>
                  </div>
                </span>
                <ValidationProvider
                  mode="passive"
                  vid="couponCode"
                  :name="$t('front_end.a060.coupon_code')"
                  rules="max:6|number_alphabet_character"
                  v-slot="{ errors, failedRules }"
                  v-if="!isReOrder"
                >
                  <div class="content-enter-number-sheet mt-4">
                    <div class="sheet-bring">
                      <p
                        class="content-print-content-font-ttl"
                      >{{ $t("front_end.a060.coupon_code") }}</p>
                      <p
                        class="w-100 m-0 message-error"
                        v-if="failedRules.number_alphabet_character"
                      >{{ $t("front_end.a060.validate.invalid_coupon_code") }}</p>
                      <p
                        class="w-100 m-0 message-error"
                        v-else-if="errors.length !== 0"
                      >{{ errors[0] }}</p>
                      <p class="w-100 m-0 message-error" v-else>{{ $t(couponCodeError[0]) }}</p>
                    </div>
                    <div class="enter-number-sheet">
                      <input
                        type="text"
                        class="form-control content-enter-input mr-2 p-0 fix-text"
                        v-model.trim="couponCode"
                      />
                    </div>
                  </div>
                </ValidationProvider>
              </div>
            </div>
            <div class="btn-footer mt-3">
              <div class="content-print-content-footer text-left">
                <button
                  :class="['btn-edit-template', {'button-disabled':isReOrder}]"
                  :disabled="isReOrder"
                  type="button"
                  @click="showEditingAlert()"
                >{{$t('front_end.a060.re_edit')}}</button>
              </div>
              <div class="content-print-content-footer text-right">
                <button class="btn-confirm-postcard" type="submit">{{$t('front_end.a060.confirm')}}</button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
    <fe-alert ref="alertComponent" :datas="dataAlert">
      <template v-slot:default>
        <div class="form-group text-center cursor-default text-box">{{ dataAlert.content }}</div>
      </template>
      <template v-slot:action>
        <button
          type="button"
          @click="redirectToEditingComponent()"
          class="btn-dialog col-6 border-top border-right"
        >{{ dataAlert.confirmText }}</button>
        <button
          type="button"
          @click="onModalConfirmCancel"
          class="btn-dialog col-6 border-top border-left"
        >{{ dataAlert.dismissText }}</button>
      </template>
    </fe-alert>
  </div>
</template>
<script>
import apiEndPoint from "../../services/apiEndpoints";
import Api from "../../services/api";
import FeAlert from "../../components/fe/common/FeAlert";
import { mapGetters, mapState } from "vuex";
import deviceUtil from "@/utils/deviceUtil";
var md5 = require("md5");

const FROMA060 = "a060";
const MAX_PRINT_NUMBER = 1000;

export default {
  name: "a060",
  components: {
    FeAlert
  },
  data() {
    return {
      isShopMode: false,
      postcardList: [],
      postcardSelect: null,
      templateEdit: null,
      messageValidate: "",
      isEditTemplate: false,
      messageConfirmEdit: this.$t("front_end.a060.confirm_edit"),
      btnConfirm: this.$t("front_end.a060.yes"),
      btnCancel: this.$t("front_end.a060.cancel"),
      typeTemplate: 1,
      // isReOrder: false,
      inputTotal: "",
      postcardBring: "",
      error: {
        postcardSelect: "",
        inputTotal: "",
        postcardBring: ""
      },
      dataOrderInfo: {},
      isiPad: false,
      isMobile: false,
      isAndroid: false,
      // fakeConfig
      configFake: {
        is_display_postcard: false
      },
      postcardInfomation: [],
      isNumberPrintError: [],
      isBringIntoQuantityError: [],
      dataAlert: {},
      couponCode: "",
      couponCodeError: [],
      behindImage: ""
    };
  },
  async created() {
    this.isShopMode = !!this.shopMode?.shopName
    this.getPostCardList();
    document.addEventListener("keydown", function(e) {
      if (e.keyCode === 13 && e.target.nodeName.toLowerCase() === "input") {
        e.preventDefault();
      }
    });
  },
  mounted() {
    this.$root.$on("header-back", this.backBtnHandle);
    this.getPrintContentsFromStore();
    this.getImageBackFromOrderNoHashed(this.orderNo);
  },
  beforeDestroy() {
    this.$root.$off("header-back", this.backBtnHandle);
  },
  computed: {
    frontImage: function() {
      let postCard = this.getPostCardSelected();
      return postCard ? postCard.imageURL : "";
    },
    ...mapGetters(['shopMode']),
    ...mapState({
      definision: state => state.userData.selected.definision ?? "",
      orderNo: state => state.userData.order.orderNo ?? "",
      orderInfo: state => state.userData.order,
      templateActive: state => state.userData.templates.templateActive ?? {},
      isModeShop: state => (state.shopMode.shopId !== "" ? true : false),
      isBringPostcard: state => state.userData.selected.is_bring_in,
      receivers: state => state.userData.order.receivers ?? [],
      printContens: state => state.userData.order.printContens,
      reOrder: state => state.userData.order.reOrder,
      category: state => state.userData.selected.category ?? "",
      isConinueFromTemporary: state =>
        state.userData.order.isConinueFromTemporary ?? false,
      isPrintAddress: state => state.userData.selected.is_print_address ?? false
    }),
    printReceiver: function() {
      return this.receivers.length !== 0 && this.isPrintAddress ? true : false;
    },
    isCanBringPostCard: function() {
      return this.isModeShop && this.isBringPostcard;
    },
    total: function() {
      let total = "";
      if (this.inputTotal !== "") {
        total = this.inputTotal;
      } else if (this.addressReceiverNumber) {
        total =
          this.addressReceiverNumber !== 0 ? this.addressReceiverNumber : "";
      }
      return total;
    },
    noneAddressReceiverNumber: function() {
      if(!this.isPrintAddress) {
        return 0;
      }
      return this.total - this.addressReceiverNumber;
    },
    addressReceiverNumber: function() {
      if(!this.isPrintAddress) {
        return 0;
      }
      return this.receivers.filter(function(re) {
        return re.address ? re.address.trim() !== "" : false;
      }).length;
    },
    inputType() {
      return deviceUtil.isPc() ? "text" : "number";
    },
    dynamicPattern() {
      return deviceUtil.isiOS() ? "\\d*" : ".*";
    },
    isReOrder() {
      return !!this.reOrder;
    }
  },
  methods: {
    getPrintContentsFromStore() {
      if (this.printContens) {
        this.postcardSelect = this.printContens.postcardType;
        this.inputTotal = this.printContens.quantity ?? "";
        this.postcardBring = this.printContens.numberOfBringIn ?? "";
        this.couponCode = this.printContens.couponCode ?? "";
      }
    },
    backBtnHandle() {
      let isPrintNameReceiver = this.$store.state.userData.selected
        .is_print_address;
      this.savePrintContentIntoStore();
      if (isPrintNameReceiver) {
        this.$router.push({ name: "a050" });
      } else {
        this.$router.push({ name: "a035" });
      }
    },
    getPostCardSelected() {
      let self = this;
      return self.postcardList.filter(ps => {
        return ps.postCardName == self.postcardSelect;
      })[0];
    },
    getPostCardList() {
      Api.post(apiEndPoint.getPostcards, {
        definision: this.definision,
        category: this.category
      })
        .then(({ data }) => {
          this.postcardList = data.postcardInfomation ?? [];
        })
        .catch(e => {
          console.log(e);
        });
    },
    setFrameImg() {
      return "";
    },
    async onSubmit() {
      let isValidNumberPrint = this.checkNumberPrint();
      let isValid = await this.$refs["form"].validate();
      if (!isValid || !isValidNumberPrint) {
        return "";
      }
      this.updatePrintContens();
    },
    async updatePrintContens() {
      let param = {
        orderNo: this.orderNo,
        printContens: {
          postcardType: this.postcardSelect,
          quantity: Number(this.inputTotal),
          numberOfBringIn: !!this.postcardBring && this.isCanBringPostCard ? Number(this.postcardBring) : 0,
          quantityPrintName: Number(this.addressReceiverNumber),
          quantityNoPrintName: Number(this.noneAddressReceiverNumber),
          couponCode: this.isReOrder ? "" : this.couponCode
        }
      };
      try {
        let result = await Api.post(apiEndPoint.updatePrintContens, param);
        if (result) {
          this.savePrintContentIntoStore();
          if (this.isShopMode) {
            this.$router.push({ name: 'a065' })
          } else {
            this.$router.push({ name: 'a125' })

          }
        }
      } catch (e) {
        if (e.response.status == 409) {
          this.couponCodeError = [
            "front_end.a060.validate.coupon_code_not_exists"
          ];
        } else {
          let status = e.response.status;
          let message = "front_end.common.error_page.error" + status;
          this.$store.dispatch("errorStore/redirectErrorPage", {
            status: status,
            message: message
          });
        }
      }
    },
    async checkValidateForm() {
      return await this.$refs["form"].validate();
    },
    checkNumberPrint() {
      this.isNumberPrintError = [];
      this.isBringIntoQuantityError = [];
      if (Number(this.addressReceiverNumber) > Number(this.inputTotal))
        this.isNumberPrintError = [
          "front_end.a060.validate.number_print_less_address"
        ];
      if (
        Number(this.postcardBring) > Number(this.inputTotal) &&
        this.isBringPostcard
      )
        this.isBringIntoQuantityError = [
          "front_end.a060.validate.postcard_bring_limit_total"
        ];

      if (Number(this.inputTotal) % 10 !== 0 && !this.isReOrder)
        this.isNumberPrintError = ["front_end.a060.validate.min_input_print"];
      if (Number(this.total) > MAX_PRINT_NUMBER)
        this.isNumberPrintError = [
          "front_end.a060.validate.maximun_print_number"
        ];
      return (
        this.isNumberPrintError.length === 0 &&
        this.isBringIntoQuantityError.length === 0
      );
    },
    toggleAlert() {
      this.$refs["alertComponent"].show();
    },
    redirectBack() {
      // this.$router.push({ name: "a020" });

      location.href =
        "/editor/" + this.templateActive.templateId + "?from=" + FROMA060;
    },
    redirectToEditingComponent() {
      //ha.ngocam add for a025 need check
      this.$store.commit("userData/SET_SELECTED", {
        confirm_edited: true
      });
      this.savePrintContentIntoStore();
      // this.$router.push({ name: "a020" });
      let ohQuery = "&oh=";
      if (this.reOrder) {
        ohQuery += md5(this.reOrder);
      } else if (this.isConinueFromTemporary) {
        ohQuery += md5(this.orderNo);
      } else {
        ohQuery += md5(this.orderNo);
      }

      location.href =
        "/editor/" +
        this.templateActive.templateId +
        "?from=" +
        FROMA060 +
        ohQuery;
    },
    showEditingAlert() {
      this.dataAlert = {
        content: this.messageConfirmEdit,
        confirmText: this.$t("front_end.a060.yes"),
        dismissText: this.$t("front_end.a060.cancel"),
        isShowClose: true
      };
      this.$refs["alertComponent"].show();
    },
    savePrintContentIntoStore() {
      let orderInfo = this.orderInfo;
      orderInfo.thumbnailFrontURL = this.frontImage;
      orderInfo.printContens = {
        postcardType: this.postcardSelect,
        quantity: this.inputTotal ? Number(this.inputTotal) : "",
        numberOfBringIn: !!this.postcardBring && this.isCanBringPostCard ? Number(this.postcardBring) : "",
        quantityPrintName: Number(this.addressReceiverNumber),
        quantityNoPrintName: Number(this.noneAddressReceiverNumber),
        couponCode: this.isReOrder ? "" : this.couponCode
      };
      this.$store.commit("userData/SET_ORDER", orderInfo);
    },
    onModalConfirmCancel() {
      this.$refs["alertComponent"].hide();
    },
    async getImageBackFromOrderNoHashed(orderNo) {
      let respEdu = await Api.post(apiEndPoint.editDataUploadUrl, {
        orderNo: orderNo,
        filename: "preview-image-" + orderNo,
        accessType: "preview"
      });

      // console.log("respEdu", respEdu);
      if (respEdu && respEdu.data?.url) {
        this.behindImage = respEdu.data.url;
      }
    }
  }
};
</script>
<style lang="css" scoped src="../../assets/css/confirmPostcard/confirmPostcard.css"></style>
<style scoped>
.message-error-size,
.inline-error-noti,
.message-error {
  font-size: 12px;
}
@media screen and (max-width: 768px) {
  .message-error-size,
  .inline-error-noti,
  .message-error {
    font-size: 11px;
  }
}

.note-required {
  color: red;
  font-size: 15px;
}
.input-total-box {
  max-width: 84px;
}
.fix-text {
  margin-right: 22px !important;
}
img {
  padding: 5px;
}
.icon-select {
  color: red;
  position: absolute;
  right: 0;
  font-size: 25px;
  margin: 10px;
}
.enter-number-sheet {
  width: 20%;
}
.content-enter-input {
  /* width: 100%; */
  width: calc(100% - 20px);
}
@media screen and (min-width: 1024px) {
  .icon-select {
    font-size: 25px;
    margin: 10px;
  }
}
@media screen and (max-width: 1024px) {
  .input-total-box {
    width: 37.33%;
  }
  #selectPostCard {
    padding: 0 10px !important;
  }
}
@media screen and (max-width: 768px) {
  .icon-select {
    font-size: 15px;
    margin: 10px;
  }
  .icon-select {
    font-size: 20px;
  }
  .input-total-box {
    width: 37.33%;
  }
  .select-postcard {
    font-size: 12px;
    height: 30px;
  }
}

@media screen and (max-width: 480px) {
  .icon-select {
    font-size: 13px;
  }
  .form-control {
    font-size: 10px;
  }
  .select-box select {
    height: 30px;
  }
  .content-print-content-footer button {
    font-size: 10px;
  }
  .input-total-box {
    width: 38%;
  }
}
@media screen and (max-width: 320px) {
  .input-total-box {
    width: 37.33%;
  }
}
.text-box {
  margin-top: 22px;
}
select#selectPostCard {
  position: relative;
  display: block;
  background: transparent;
  padding-right: 30px;
}

.icon-select {
  color: red;
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  margin: 0 7px;
}
.customer-enter-box {
  width: 40%;
}
</style>
